module.exports = __webpack_public_path__ + "img/portraits_16_V.182c05df.webp";